import {Component, Input, OnInit} from '@angular/core';
import {ReservationService} from '../../services/reservation.service';

@Component({
  selector: 'app-reservation-card-small',
  templateUrl: './reservation-card-small.component.html',
  styleUrls: ['./reservation-card-small.component.scss']
})
export class ReservationCardSmallComponent implements OnInit {

  @Input() reservation: any;

  constructor(private reservationService: ReservationService) { }

  ngOnInit(): void {
  }


  setArchived() {
    this.reservationService.reservationArchiveStatusChange(this.reservation.id);
    this.reservation.archived = !this.reservation.archived;
  }

}
